import { is3pApp } from '@atlassian/conversation-assistant-chat-prompt-input/utils/is-3p-app';

/** Why a user is or is not in the 3P suggested-prompts experiment. */
export type ThirdPartyEligibility = {
	/** The admin has allowed at least one 3P knowledge source. */
	isEligible: boolean;
	adminAllowed3pAppCount: number;
	/** Count of all admin-allowed knowledge sources (1P + 3P), not only the 3P ones. */
	knowledgeSourceCount: number;
	/** The connectors fetch errored, so `isEligible: false` means "couldn't determine". */
	connectorsErrored: boolean;
};

/**
 * The one eligibility rule, shared with `useThirdPartySuggestedPromptEligibility` — which gates the
 * feature, so what is reported cannot drift from who was treated. That hook additionally reports
 * not-eligible while the connectors store is still loading; this computes from whatever is present,
 * leaving the caller to report `connectorsLoaded` alongside.
 */
export const getThirdPartyEligibility = ({
	knowledgeSources,
	connectorsErrored,
}: {
	knowledgeSources: { friendlyName: string }[];
	connectorsErrored: boolean;
}): ThirdPartyEligibility => {
	const adminAllowed3pAppCount = knowledgeSources.filter((connector) =>
		is3pApp(connector.friendlyName),
	).length;

	return {
		isEligible: adminAllowed3pAppCount > 0,
		adminAllowed3pAppCount,
		knowledgeSourceCount: knowledgeSources.length,
		connectorsErrored,
	};
};
